import { computed, ref } from 'vue'
import { useDatabase } from '../composables/database'
import { captureException } from '@sentry/vue'

const lastSyncRef = ref<Date>()
export const getLastSynced = computed(() => lastSyncRef.value)
export type LastSyncModelReturn = {
  /**
   * Returns the date the device was last synchronized.
   * @returns string as a sqlite date
   */
  lastSyncDate: () => Promise<Date>
  setLastSyncDate: (date: string) => Promise<void>
  /**
   * Clears sync dates from device
   */
  clearSyncDates: () => Promise<void>
  /**
   * Clears sync date (ref only)
   */
  resetLastSync: () => void
}
export const LastSyncModel = (): LastSyncModelReturn => {
  const { query, run } = useDatabase()

  const getFallbackDate = () => {
    const today = new Date()
    return new Date(new Date().setDate(today.getDate() - 30)) //30 days ago
  }

  const setLastSyncDate = async (date: string) => {
    const sql = `
      INSERT INTO last_sync (last_synced) VALUES (?);
    `
    console.log(sql)
    await run(sql, [date])
      .catch((error) => {
        console.log(`Error updating last sync date: ${error}`)
      })
      .then(async () => {
        console.log('no errors executing sql for last sync date')
        lastSyncRef.value = new Date(date)
      })
  }
  const lastSyncDate = async () => {
    const sql = `
          select * from last_sync order by id desc;
        `
    return await query(sql)
      .then((date) => {
        if (date && date[0]) {
          lastSyncRef.value = new Date(date[0]['last_synced'])
          return new Date(date[0]['last_synced'])
        } else {
          lastSyncRef.value = getFallbackDate()
          return getFallbackDate()
        }
      })
      .catch((error) => {
        captureException(error)
        lastSyncRef.value = getFallbackDate()
        return getFallbackDate()
      })
  }

  const clearSyncDates = async () => {
    //clean in memory state
    resetLastSync()

    //clear db
    const sql = 'delete from last_sync;'
    await run(sql, []).catch((error) => console.log(`Error deleting last sync data: ${error}`))
  }

  const resetLastSync = () => {
    lastSyncRef.value = undefined
  }
  return { lastSyncDate, setLastSyncDate, clearSyncDates, resetLastSync }
}
